<template>
  <div class="page-wrapper">
    <div class="cg-crumb">
      <btn-back />
      <span class="item">商品管理</span>
      <em class="gap">/</em>
      <span class="item">商品详情</span>
    </div>
    <div class="cg-main-title">商品详情</div>
    <div class="goods-content">
      <div class="cg-mod-title">基本信息</div>
      <div class="basic-wrap clearfix">
        <div class="img-wrap">
          <el-image
            class="img"
            :src="goodsImage"
            fit="cover"
            :preview-src-list="goodsImageList"
          ></el-image>
        </div>
        <div class="basic-info">
          <el-row>
            <el-col :span="24"><div class="line">
              <span class="lab">商品名称： </span>
              <span class="val tit">{{detail.itemName}}</span>
            </div></el-col>
            <el-col :span="8"><div class="line">
              <span class="lab">所属品牌： </span>
              <span class="val">{{detail.brand}}</span>
            </div></el-col>
            <el-col :span="16"><div class="line">
              <span class="lab">所属类目：  </span>
              <span class="val">{{detail.productCategory || '--'}}</span>
            </div></el-col>
            <el-col :span="8"><div class="line">
              <span class="lab">商品款号：  </span>
              <span class="val">{{detail.styleNumber}}</span>
            </div></el-col>
            <el-col :span="16"><div class="line">
              <span class="lab">商品ID：  </span>
              <span class="val">{{detail.item_id}}</span>
            </div></el-col>
            <el-col :span="24"><div class="line">
              <span class="lab">分佣说明：</span><br>
              <span class="val tit"  style="padding: 10px; margin-top: 10px; background: rgba(248,29,34,0.03);">分佣比例为“销售商 : 供应商={{rate_dealer}}% : {{rate_supplier}}%”；平台服务费为您分佣后获得收益的{{serviceFeeShow}}，如 单件所收服务费=单价x分佣比例x{{serviceFeeShow}}</span>
            </div></el-col>
            <el-col :span="16"><div class="line">
              <span class="lab">上传时间：  </span>
              <span class="val">{{detail.item_submit_time}}</span>
            </div></el-col>
            
          </el-row>
        </div>
      </div>
      <div class="cg-mod-title mgt">尺码数量</div>
      <div class="stock-data">
        <div class="line w-200">
          <span class="lab">销售价：</span>
          <span class="val">{{detail.price | price}} 元</span>
        </div>
        <div class="line w-200">
          <span class="lab">供货价：</span>
          <span class="val"> {{supplierPrice}} 元</span>
        </div>
        <div class="line w-200">
          <span class="lab">结算价格：</span>
          <span class="val"> {{settlePrice}} 元</span>
        </div>
        <div class="line w-200">
          <span class="lab">吊牌价：</span>
          <span class="val"> {{detail.originPrice | price}} 元</span>
        </div>
      </div>
      <div class="stock-data">
        <div class="line w-200">
          <span class="lab">总库存：</span>
          <span class="val">{{detail.totalStock}} 件</span>
        </div>
        <button class="cg-btn pos" @click="toEditStock">修改库存</button>
      </div>
      <!-- <div class="goods-size-list">
          <div class="color-list" v-for="(color_item, color_index) in sizeColorArr" :key="color_index">
              <div class="color-head">
                  <div class="t1">颜色：{{color_item.color}}</div> 
                  <div class="t2">库存小计：{{color_item.count}}件</div>
              </div>
              <div class="size-wrap">
                  <table class="size-list">
                      <tr>
                          <th>尺码</th>
                          <td v-for="(size_item, size_index) in color_item.sizeArr" :key="size_index">{{size_item.name}}</td>
                      </tr>
                      <tr>
                          <th>库存</th>
                          <td v-for="(number_item, number_index) in color_item.sizeArr" :key="number_index">{{number_item.number}}</td>
                      </tr>
                  </table>
              </div>
          </div>
      </div> -->
      <div class="goods-size-list">
        <table class="table">
          <thead>
            <tr class="th">
                <th width="20%">颜色</th>
                <th width="20%">尺码</th>
                <th width="30%">库存</th>
                <th width="">小计</th>
            </tr>
          </thead>               
          <tbody v-for="(p_item, p_index) in sizeColorArr" :key="p_index">
            <tr v-for="(s_item, s_index) in p_item.sizeArr" :key="s_index" >
              <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.color}}</td>
              <td>{{s_item.name}}</td>
              <td>
                  {{s_item.number}}
              </td>
              <td v-if="s_index == 0" :rowspan="p_item.sizeArr.length">{{p_item.count}}</td>
            </tr>             
          </tbody>
        </table>
      </div>

      <div class="cg-mod-title mgt">面辅料信息</div>
      <div class="stock-data bottom-line">
        <div class="line">
          <span class="lab">主面料名称:  </span>
          <span class="val">{{fabricAndAccessory.fabricName}}</span>
        </div>
        <div class="line">
          <span class="lab">主面料成分：</span>
          <span class="val">{{fabricAndAccessory.fabricIngredient}}</span>
        </div>
        <div class="line">
          <span class="lab">填充物： </span>
          <span class="val">{{fabricAndAccessory.fabricStuffing}}</span>
        </div>
      </div>

      <div class="cg-mod-title mgt">商品详情</div>
      <div class="rich-text-wrap w-e-text" v-html="detail.productContent">
      </div>
    </div>
  </div>
</template>

<script>
import { getMallItemInfo } from '../../../api/supplier'
import { settlePrice, supplierPrice, accMul, accSub } from '../../../utils/tools'
import { mapGetters } from 'vuex'
import NP from 'number-precision'

export default {
    data() {
      return {
        goodsImage: '',
        goodsImageList: [],
        detail: {
          brand: '',
          fabricAndAccessoryStr: '',
          itemName: '',
          itemState:  '',
          itemUnqueNumber:  '',
          item_fee_splitting:  '',
          item_id:  '',
          item_parent_id:  '',
          item_submit_time:  '',
          mallItemFileUrl:  '',
          originPrice: '',
          price:  '',
          productCategory:  '',
          productContent:  '',
          sizeArr:  '',
          styleNumber:  '',
          totalStock:  '',
          user_id:  '',
        },
        rate_dealer: '',
        rate_supplier: '',
        fabricAndAccessory: {
          fabricName: '',
          fabricStuffing: '',
          fabricIngredient: ''
        },
        sizeColorGroup: {},
        sizeColorArr: []
      }
    },
    computed: {
      ...mapGetters(['userId', 'globalServiceCharge']),
      serviceFeeShow: function () {
        return NP.times(100, this.globalServiceCharge) + '%'
      },
      settlePrice: function () {
        return settlePrice(this.detail.price, this.rate_supplier)
      },
      supplierPrice: function () {
        return supplierPrice(this.detail.price, this.rate_supplier)
      },
    },
    created() {
      console.log(this.$route)
      this.getMallItemInfo();
    },
    methods: {
      getMallItemInfo() {
        getMallItemInfo({
          itemId: this.$route.query.id,
          userId: this.userId
        }).then(res => {
          console.log(res)
          if (res.errorCode == 200) {
            this.detail = res.data[0]
            this.goodsImage = process.env.VUE_APP_IMG_PREV + res.data[0].mallItemFileUrl
            this.goodsImageList.push(this.goodsImage)
            let rate_supplier = res.data[0].item_fee_splitting.split(',')[1]
            this.rate_supplier = rate_supplier ? accMul(rate_supplier, 100) : '--'
            this.rate_dealer = accSub(100, this.rate_supplier)
            try {
              let fab= JSON.parse(res.data[0].fabricAndAccessoryStr)
              this.fabricAndAccessory = {
                fabricName: fab.fabricName || '--',
                fabricStuffing: fab.fabricStuffing || '--',
                fabricIngredient: fab.fabricIngredient_type == 1 ? fab.fabricIngredient_custom || '--' : fab.fabricIngredient_seclet || '--'
              }
            } catch (error) {
              console.log(error)
              this.fabricAndAccessory = {
                fabricName: '--',
                fabricStuffing: '--',
                fabricIngredient: '--'
              }
            }
            try {
              let group = JSON.parse(res.data[0].sizeArr)
              let arr = group.group.map(item => {
                return {
                  ...item,
                  count: item.sizeArr.reduce((total, item) => {
                    return total + item.number
                  }, 0)
                }
              })
              this.sizeColorArr = arr || []
              console.log(this.sizeColorArr)
            } catch (error) {
              console.log(error)
              this.sizeColorArr = []
            }
            
          } else {
            this.$message.error(res.errorMsg || '获取详情数据异常')
          }
        }).catch(err => {
          console.log(err)
        })
      },
      toEditStock() {
        this.$router.push('/supplier/stock/edit?id=' + this.$route.query.id)
      }
    }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 24px 24px;
  min-width: 1000px;
}
.goods-content {
  margin-top: 16px;
  padding: 8px 24px 24px;
  background: #fff;
}
.basic-wrap {
  padding: 24px 0;
  border-bottom: 1px solid rgba(0,0,0,0.06);
  .img-wrap {
    float: left;
    width: 100px; height: 100px;
    border: 1px solid #f0f0f0;
    .img {
      width: 100px; height: 100px;
    }
  }
  .basic-info {
    padding-left: 136px;
    .line {
      padding-bottom: 16px;
      font-size:14px;
      line-height:22px;
      .lab {
        color:rgba(0,0,0,0.85);
      }
      .val {
        color:rgba(0,0,0,0.65);
        &.tit {
           display: inline-block;
           vertical-align: top;
           width: 720px;
        }
      }
    }
  }
}
.cg-mod-title.mgt {
  margin-top: 32px;
}
.stock-data {
  width: 900px;
  height: 22px;
  margin: 24px 0;
  position: relative;
  .line {
    float: left;
    width: 290px;
    font-size:14px;
    line-height:22px;
    &.w-200 {width: 200px;}
    .lab {
      color:rgba(0,0,0,0.85);
    }
    .val {
      color:rgba(0,0,0,0.65);
    }
  }
  .cg-btn.pos {
    position: absolute;
    top: 0; right: 0;
  }
  &.bottom-line {
    padding-bottom: 32px;
    border-bottom: 1px solid rgba(0,0,0,0.06);
  }
}
.goods-size-list {
  .table {
    border: 1px solid #E6E6E6;
    width: 900px;
    border-spacing: 0;
    border-collapse: collapse;
    font-size:14px;
    tr {
      height: 40px;
    }
    tr.th {
      background: #fafafa;
    }
    tr th {
      color:rgba(0,0,0,0.85);
      font-weight: normal;
    }
    td {
      border: 1px solid #E6E6E6;
      text-align: center;
      color:rgba(0,0,0,0.85);
    }
  }
  &.clearing {
      margin-top: 24px;
  }
  &.clearing tr th {
    border: 1px solid #E6E6E6;
  }
  &.clearing tr th:last-child, &.clearing tr td:last-child{
    color: #F81D22;
  }
}


</style>